import { writable } from "svelte/store";
import ShapeType from "./ShapeType";
const EditStore = {
	shape: {
		type: writable(ShapeType.POINTS),
		color: writable("#000000"),
		colorRGBA: writable([0, 0, 0, 1]),
		properties: writable({}),
		index: writable(-1)
	},
	meta: {
		visible: writable(false),
		lastUpdated: writable(0)
	}
};
export default EditStore;
